/*
 * Shared frontend field validation helpers.
 * Single source of truth so every form validates email the same way,
 * with the same messages.
 */

// Email format used across all forms.
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Validate an email address.
 *
 * @param {string} value - the email to check
 * @returns {string|null} an error message, or null when the value is valid
 */
export function validateEmail(value) {
  if (!value || value.trim() === '') {
    return 'Email is required';
  }
  if (!EMAIL_REGEX.test(value.trim())) {
    return 'Please enter a valid email address';
  }
  return null;
}

// Minimum characters required for a prescription name (trimmed).
export const NAME_MIN_LENGTH = 3;

/**
 * Validate a prescription name.
 *
 * @param {string} value - the name to check
 * @returns {string|null} an error message, or null when the value is valid
 */
export function validateName(value) {
  const trimmed = (value || '').trim();
  if (trimmed === '') {
    return 'Name is required';
  }
  if (trimmed.length < NAME_MIN_LENGTH) {
    return `Name must be at least ${NAME_MIN_LENGTH} characters`;
  }
  return null;
}
